function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import App from 'modules/App';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Dropdown from 'svg/dropdown.svg';
import * as patientResultsConstants from 'modules/PatientResults/constants';
import messages from '../../messages';
import styles from './KpiSetting.pcss';
var _React_PureComponent;
class KpiSetting extends (_React_PureComponent = React.PureComponent) {
    get diabetesTypes() {
        return App.constants.DIABETES_TYPES.filter((diabetesType)=>!App.constants.DIABETES_TYPES_HIDE_FOR_HCP.includes(diabetesType));
    }
    renderOption(id, option) {
        const { isDisabled } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx(FormGroup, {
                id: id,
                labelMessage: messages.labels[option],
                formValues: this.props.formValues,
                children: /*#__PURE__*/ _jsx(Input, {
                    placeholder: messages.placeholders[option],
                    onChange: (input)=>this.props.onSetValue(input),
                    isDisabled: isDisabled
                })
            })
        }, `container-${id}`);
    }
    renderInfo() {
        const { type, conversion, labelMessage } = this.props;
        if (!labelMessage) return null;
        let target = '';
        if (type === 'veryHigh') {
            target = `${patientResultsConstants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].veryHigh} 
      ${conversion.unitSymbol}`;
        }
        if (type === 'veryLow') {
            target = `${patientResultsConstants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].low} 
      ${conversion.unitSymbol}`;
        }
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, labelMessage), {
            values: {
                target
            }
        }));
    }
    renderOptions() {
        const { possibleOptions, type, allowConigurationPerDiabetesType } = this.props;
        if (!allowConigurationPerDiabetesType) {
            return /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-4",
                        children: possibleOptions.map((option)=>/*#__PURE__*/ _jsx("div", {
                                children: this.renderOption(`kpi-${type}-${option}`, option)
                            }, `kpi-${type}-${option}-wrapper`))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn('col-8', styles.itemInfo, styles['itemInfo--single']),
                        children: this.renderInfo()
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: cn('col-12', styles.itemInfo),
                    children: this.renderInfo()
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `col-${possibleOptions.length === 1 ? 6 : 12}`,
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: cn('caption', styles.optionHeader),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.kpiDefault))
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "row",
                            children: possibleOptions.map((option)=>/*#__PURE__*/ _jsx("div", {
                                    className: `col-${possibleOptions.length === 1 ? 12 : 6}`,
                                    children: this.renderOption(`kpi-${type}-${option}`, option)
                                }, `kpi-${type}-${option}-wrapper`))
                        })
                    ]
                }),
                this.diabetesTypes.map((diabetesType)=>/*#__PURE__*/ _jsxs("div", {
                        className: `col-${possibleOptions.length === 1 ? 6 : 12}`,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: cn('caption', styles.optionHeader),
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.diabetesTypes[diabetesType]))
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "row",
                                children: possibleOptions.map((option)=>/*#__PURE__*/ _jsx("div", {
                                        className: `col-${possibleOptions.length === 1 ? 12 : 6}`,
                                        children: this.renderOption(`kpi-${type}-diabetesType-${diabetesType}-${option}`, option)
                                    }, `kpi-${type}-diabetesType-${diabetesType}-${option}-wrapper`))
                            })
                        ]
                    }, `option-${diabetesType}-container`))
            ]
        });
    }
    render() {
        const { type } = this.props;
        const { isOpen } = this.state;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.settingItem_container,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.settingItem_header,
                    onClick: ()=>this.setState({
                            isOpen: !isOpen
                        }),
                    role: "presentation",
                    children: /*#__PURE__*/ _jsxs("h2", {
                        className: cn('title', styles.title_header),
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers[`kpi${type}`])),
                            /*#__PURE__*/ _jsx(motion.div, {
                                initial: {
                                    rotate: '180deg'
                                },
                                animate: isOpen ? 'open' : 'close',
                                variants: {
                                    open: {
                                        rotate: '180deg'
                                    },
                                    close: {
                                        rotate: '0deg'
                                    }
                                },
                                children: /*#__PURE__*/ _jsx(Dropdown, {})
                            })
                        ]
                    })
                }),
                isOpen && /*#__PURE__*/ _jsx(motion.div, {
                    initial: {
                        height: 0,
                        opacity: 0
                    },
                    animate: {
                        height: isOpen ? 'auto' : 0,
                        opacity: isOpen ? 1 : 0
                    },
                    transition: {
                        ease: 'easeOut',
                        duration: 0.15
                    },
                    children: this.renderOptions()
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isOpen: false
        };
    }
}
_define_property(KpiSetting, "propTypes", {
    // Explicit props
    formValues: PropTypes.object,
    isDisabled: PropTypes.bool,
    type: PropTypes.string,
    conversion: PropTypes.object,
    possibleOptions: PropTypes.arrayOf(PropTypes.oneOf([
        'allowedMeasurements',
        'valueHigh',
        'valueLow'
    ])),
    allowConigurationPerDiabetesType: PropTypes.bool,
    labelMessage: PropTypes.object,
    // Explicit actions
    onSetValue: PropTypes.func
});
export default withStyles(styles)(KpiSetting);
